import React, {Component} from 'react';
import {connect} from 'formik';
import get from 'lodash/get';
import {constants} from '@neosvoc/nv-platform-core-common';
import CustomRadio from './CustomRadio';
import Error from '../Error';

class SingleChoiceBatteryField extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        this.props.formik.registerField(this.props.id, this);
    }

    componentWillUnmount() {
        this.props.formik.unregisterField(this.props.id);
    }

    componentDidUpdate(prevProps) {
        if (this.props.id !== prevProps.id) {
            this.props.formik.unregisterField(prevProps.id);
            this.props.formik.registerField(this.props.id, this);
        }
    }

    handleChange(e) {
        const checkedId = e.target.dataset.id;
        const checkedValue = e.target.value;
        const {formik, id, value} = this.props;
        const newValue = Object.assign({}, value);

        newValue[checkedId] = checkedValue;
        formik.setFieldValue(id, newValue, true);
    }

    render() {
        const {form, field, choices, id, rows, value} = this.props;
        const error = get(form.errors, field.name);
        const touched = get(form.touched, field.name);
        let errorRows = [];

        const rowErrors = [
            constants.PARSER_ERRORS.REQUIRED,
            constants.PARSER_ERRORS.OCCURRENCIES,
            constants.PARSER_ERRORS.MIN_OCCURRENCIES,
            constants.PARSER_ERRORS.MAX_OCCURRENCIES,
        ];

        if (touched && error && rowErrors.includes(error.reason)) {
            errorRows = error.reasonParams[0]['errorRows'];
        }
        return (
            <>
                <div className="battery-list d-block d-sm-none">
                    {rows.map((row, rowIndex) => (
                        <div key={`${row.id}`}>
                            <h3 dangerouslySetInnerHTML={{__html: row.value}} />
                            {choices.map((c, i) => (
                                <CustomRadio key={i} id={`singlechoicebatterylist-${id}_${rowIndex}_${c.id}`}
                                    name={`singlechoicebatterylist-${id}.${row.id}`} checked={value[row.id] === c.id} data-id={row.id} value={c.id}
                                    onChange={this.handleChange}>
                                    {c.value}
                                </CustomRadio>
                            ))}
                            {errorRows.includes(row.id) && <Error {...error} />}
                        </div>
                    ))}
                </div>
                <table className="table d-none d-sm-table battery">
                    <thead>
                        <tr>
                            <th />
                            {choices.map((choice) => <th key={choice.id} className="battery-cell">{choice.value}</th>)}
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, rowIndex) => (
                            <React.Fragment key={`fragment_${row.id}`}>
                                <tr key={rowIndex}>
                                    <th dangerouslySetInnerHTML={{__html: row.value}} />
                                    {choices.map((c) => (
                                        <td key={c.id} className="battery-cell">
                                            <CustomRadio id={`singlechoicebattery-${id}_${rowIndex}_${c.id}`} name={`singlechoicebattery-${id}.${row.id}`}
                                                checked={value[row.id] === c.id} data-id={row.id} value={c.id} onChange={this.handleChange}>
                                                &nbsp;
                                            </CustomRadio>
                                        </td>
                                    ))}
                                </tr>
                                <tr key={`error_${row.id}`}>
                                    <td className="error-battery-span" colSpan={(choices.length+1)}>
                                        {errorRows.includes(row.id) && <><br /><Error {...error} /></>}
                                    </td>
                                </tr>
                            </React.Fragment>
                        ))}
                    </tbody>
                </table>
            </>
        );
    }
}

export default connect(SingleChoiceBatteryField);
